import { LOGO_BASE_URL } from '../../apiConfig';
import { Smartphone, Mail, Globe, Trophy, ArrowRight, Shield } from 'lucide-react';

function MobTeamProfileHeader({ data }) {
    const accentYellow = '#E7C424';

    const styles = {
        wrapper: {
            width: '100%',
            background: 'radial-gradient(circle at top, #0B15C5 0%, #060D8A 100%)',
            padding: '24px 20px',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
            color: '#FFFFFF',
            textAlign: 'center',
        },
        logoBox: {
            width: '90px',
            height: '90px',
            background: '#FFFFFF',
            borderRadius: '12px',
            padding: '8px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0 10px 20px rgba(0,0,0,0.4)',
        },
        teamName: {
            fontFamily: 'var(--fontAnton)',
            fontSize: '28px',
            lineHeight: 1.1,
            textTransform: 'uppercase',
            margin: 1,
            letterSpacing: '0',
        },
        identityBar: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
            width: '100%',
            padding: '12px',
            background: 'rgba(0,0,0,0.2)',
            borderRadius: '12px',
            border: '1px solid rgba(255,255,255,0.1)',
        },
        statItem: {
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '12px',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            fontFamily: 'var(--fontInter)',
        },
        actionSection: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
            marginTop: '4px',
        },
        websiteBtn: {
            background: '#FFFFFF',
            color: '#060D8A',
            padding: '10px 20px',
            textDecoration: 'none',
            fontSize: '13px',
            fontWeight: 800,
            textTransform: 'uppercase',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            width: 'fit-content',
            fontFamily: 'var(--fontAnton)',
            letterSpacing: '1px',
        },
        contactList: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '16px',
            opacity: 0.8,
            flexWrap: 'wrap',
            justifyContent: 'center',
        },
        contactItem: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '12px',
            fontFamily: 'var(--fontInter)',
        }
    };

    return (
        <div style={styles.wrapper}>
            <div style={styles.logoBox}>
                <img 
                    src={data.imglogo ? `${LOGO_BASE_URL}/${data.imglogo}` : ""} 
                    alt={data.name} 
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }} 
                />
            </div>

            <h1 style={styles.teamName}>{data.name}</h1>

            <div style={styles.identityBar}>
                <div style={styles.statItem}>
                    <Shield size={16} color={accentYellow} fill={accentYellow} />
                    <span>{data.division_name || 'PREMIER DIVISION'}</span>
                </div>
                <div style={styles.statItem}>
                    <Trophy size={16} color={accentYellow} />
                    <span>{data.champions_years || '2015, 2018, 2020'}</span>
                </div>
                <div style={styles.statItem}>
                    <Globe size={16} opacity={0.6} />
                    <span style={{opacity: 0.6}}>PC ID: {data.pc_team_id}</span>
                </div>
            </div>

            <div style={styles.actionSection}>
                <a href={data.web_link} target="_blank" rel="noreferrer" style={styles.websiteBtn}>
                    Visit Website <ArrowRight size={16} />
                </a>
                
                <div style={styles.contactList}>
                    <div style={styles.contactItem}>
                        <Smartphone size={16} color={accentYellow} />
                        <span>{data.contactno}</span>
                    </div>
                    <div style={styles.contactItem}>
                        <Mail size={16} color={accentYellow} />
                        <span style={{textTransform: 'lowercase'}}>{data.email}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MobTeamProfileHeader;